const ErrorMessage = ({ children }) => {
  return (
    <div className="w-full bg-errorBackground text-errorColor p-2 my-2 text-sm	font-medium leading-6">
      {children}
    </div>
  );
};

export default ErrorMessage;
